import { defineComponent } from 'vue';
export default defineComponent({
  name: 'LastHourFeed',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup: function setup(props, ctx) {
    return {};
  }
});